import axios from "axios";
import { useRef, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";

import BASE_URL from "../constants/baseURL";
import { alert } from "../redux/slices/alertSlice";
import { apiError } from "../redux/slices/loaderSlice";
import { deleteAccessToken } from "../redux/slices/memberSlice";
import { useNavigate } from "react-router-dom";

export default function useAxios({
  baseURL = "mox_api",
  customBaseURL = "",
  customAuthToken = "",
  disableAuthToken = false,
} = {}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authToken } = useSelector((state) => state.memberDetails);

  const axiosInstance = useRef(axios.create());

  useEffect(() => {
    axiosInstance.current = axios.create({
      headers: {
        ...(!disableAuthToken && {
          Authorization: "Bearer " + (customAuthToken || authToken),
        }),
        "x-api-key": "ziYSCXNw9J50ayP3HdV9N2hC3FL90SIL4OUOmB4T",
        "client-key": "dg_live_n4MZ0OifkNgNzp-Acj_OmXQ7Wuqymlij",
      },

      ...(Boolean(customBaseURL)
        ? { baseURL: customBaseURL }
        : {
            baseURL: BASE_URL[baseURL].url + BASE_URL[baseURL].version,
          }),

      validateStatus: (status) => status < 500,
    });
  }, [authToken, baseURL, customAuthToken, customBaseURL, disableAuthToken]);

  return useCallback(
    ({
      url,
      method = "GET",
      data,
      params,
      disableRedirect = false,
      disableError = false,
      customAuthToken,
    }) =>
      axiosInstance
        .current({
          url: url,
          method: method,
          data: data,
          params: params,
          headers: {
            ...(!disableAuthToken && {
              Authorization: "Bearer " + (customAuthToken || authToken),
            }),
          },
        })
        .then((response) => {
          console.log(response.status, "response.data.detail?.code");

          if (response.status >= 500 || response.status == 404) {
            navigate("/error-500"); // 👈 redirect to custom error page
            return;
          }

          if (
            response.data.detail?.code === "#401" ||
            response.data.detail?.code === "1401" ||
            response.data.detail?.code === "401"
          ) {
            let autoRefresh = response.data.detail.auto_refresh;
            let refreshToken = response.data.detail.refresh_token;
            if (!autoRefresh) {
              // dispatch(
              //   alert({
              //     message:
              //       "Could not validate your credentials. Please log in again",
              //     type: "error",
              //   })
              // );
              return dispatch(deleteAccessToken());
            } else {
              sessionStorage.removeItem("authToken");
              localStorage.removeItem("authToken");
              sessionStorage.setItem("authToken", refreshToken);
              localStorage.setItem("authToken", refreshToken);
              window.location.reload();
            }
          }

          if (response.status > 201 || !response.data.status) {
            if (!disableError) {
              dispatch(
                alert({
                  message:
                    response.data.message?.displayMessage ||
                    "Something went wrong!",
                  type: "error",
                })
              );
            }
            // console.log(response, "!response!");

            if (!disableRedirect) {
              dispatch(apiError(response.data?.message?.traceID));

              throw new Error();
            } else {
              return {
                status: false,
                message: response.data.error,
                data: response.data.data,
                displayMessage:
                  response.data.message?.displayMessage ||
                  "Something went wrong!",
              };
            }
          }

          return response.data;
        })
        .catch((error) => {
          // ✅ Network / CORS / 500 error handling
          // if (
          //   !error.response || // CORS or network
          //   error.code === "ERR_NETWORK" ||
          //   (error.response && error.response.status >= 500)
          // ) {
          //   navigate("/error-500"); // 👈 redirect to custom error page
          //   return;
          // }

          if (!disableError) {
            dispatch(
              alert({
                message: "Something went wrong!",
                type: "error",
              })
            );
          }
        }),
    [dispatch]
  );
}
